import { Box } from "@twilio-paste/core/box";
import { styled } from "@twilio-paste/styling-library";
import React from "react";
import { SITE_HEADER_HEIGHT } from "../../constants";
import { SidebarNavigation } from "./SidebarNavigation";

const StyledSidebar = styled(Box)(() => ({
    height: `calc(100vh - ${SITE_HEADER_HEIGHT})`,
    WebkitOverflowScrolling: "touch"
}));

const Sidebar: React.FC = () => (
    <StyledSidebar
        as="aside"
        style={{ gridArea: "sidebar" }}
        backgroundColor="colorBackground"
        borderRight="none"
        position="sticky"
        top={SITE_HEADER_HEIGHT}
        width="21.75rem"
        display={["none", "none", "flex"]}
        flexDirection="column"
        zIndex="zIndex20"
        overflowWrap="break-word"
    >
        <SidebarNavigation />
    </StyledSidebar>
);

export { Sidebar };
